export default __webpack_public_path__ + "static/media/MarcBarette.4b0fdd88.png";